import classNames from 'clsx';
import { Tooltip } from 'aui';
import { useRef } from 'react';
import type { MdComponentIndexProps } from '../type';
import styles from './Tooltip.module.less';

export function MarkdownTooltip({
  tip,
  children,
  ...props
}: React.PropsWithChildren<{ tip: string } & MdComponentIndexProps>) {
  const ref = useRef<HTMLSpanElement>(null);
  return (
    <Tooltip
      {...{
        overlayClassName: styles.tooltip,
        showArrow: false,
        title: tip,
        getPopupContainer: () => ref.current ?? document.body,
        getTooltipContainer: () => ref.current ?? document.body,
      }}
    >
      <span ref={ref} data-first={props['data-first']} data-last={props['data-last']}>
        <span className={classNames('markdown-child-root', styles.tooltipContent)}>{children}</span>
      </span>
    </Tooltip>
  );
}

MarkdownTooltip.attributes = ['tip'];
MarkdownTooltip.inline = true;
